function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2344 1.875H14.6988C14.3117 0.783691 13.2691 0 12.0469 0C10.8246 0 9.78204 0.783691 9.39496 1.875H5.8125C4.2616 1.875 3 3.1366 3 4.6875V21.1875C3 22.7384 4.2616 24 5.8125 24H18.2373C19.7866 23.9984 21.0469 22.7368 21.0469 21.1875V4.6875C21.0469 3.1366 19.7853 1.875 18.2344 1.875ZM11.1094 3.75V2.8125C11.1094 2.29559 11.53 1.875 12.0469 1.875C12.5638 1.875 12.9844 2.29559 12.9844 2.8125V3.75H14.8594V5.57812H9.23438V3.75H11.1094ZM19.1719 21.1875C19.1719 21.7039 18.7516 22.1245 18.2364 22.125H5.8125C5.29559 22.125 4.875 21.7044 4.875 21.1875V4.6875C4.875 4.17059 5.29559 3.75 5.8125 3.75H7.35938V7.45312H16.7344V3.75H18.2344C18.7513 3.75 19.1719 4.17059 19.1719 4.6875V21.1875ZM15.6191 10.7831L17.0057 12.045L11.0015 18.6427L7.03564 14.8066L8.33936 13.459L10.9158 15.951L15.6191 10.7831Z",
  fill: "#930100"
});

function SvgAuditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditIcon);
export default __webpack_public_path__ + "static/media/audit-icon.8399057c.svg";
export { ForwardRef as ReactComponent };